module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4l.08851e39.jpg";